import { useNavBarHeight } from '@/components/AppTabBar/height'
import type { ReactNode } from 'react'
import { View } from 'react-native'

/**
 * The room a tab screen leaves for the navigation floating over its top. The bar is glass, so
 * content scrolls up under it; this spacer only sets where the content starts at rest.
 */
export const TabScreenHeader = (_props: { right?: ReactNode }) => {
	const height = useNavBarHeight((s) => s.height)
	return <View style={{ height }} />
}
